import { Injectable } from '@angular/core';
import { OptimisationMachineSelectorFactoryService } from '../../optimisationmachineselector/optimisationmachineselector-plugin-factory.service';

@Injectable()
export class InstallationEquipmentInfoPluginFactoryService extends OptimisationMachineSelectorFactoryService {
}
